import { ARBITRARY_ID_UI_STATE, DOMAIN_TYPE_ARBITRARY, } from '../../../consts';
export var getUIState = function (state) {
    return (state.domain[DOMAIN_TYPE_ARBITRARY] || {})[ARBITRARY_ID_UI_STATE] || null;
};
